module.exports = __webpack_public_path__ + "img/dashboard-active.aeed1d76.svg";